import { render, staticRenderFns } from "./User.vue?vue&type=template&id=5c809fca&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=5c809fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c809fca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DialogChangePasswordDialog: require('/home/vsts/work/1/s/components/dialog/ChangePasswordDialog.vue').default})
